import {createContext} from "react"

const AppsContext=createContext({})

export default AppsContext